import { Checkbox, Col, Row, Tooltip, Typography } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import StyledCheckbox from '../../checkbox';
import styled from 'styled-components';
import { width } from 'styled-system';
import { Flex } from 'rebass';
import { QuestionCircleOutlined } from '@ant-design/icons';

const StyledCheckboxGroup = styled(Checkbox.Group)`
  ${width}
`;

const { Text } = Typography;

export function CheckboxGroupControl({ name, value, settings, onChange, ...props }) {
  const { options, gutter, span = 24, ...rest } = settings;

  return (
    <StyledCheckboxGroup
      name={name}
      value={value}
      onChange={value => {
        onChange({
          target: { name, value },
        });
      }}
      {...rest}
      {...props}
    >
      <Row gutter={gutter}>
        {options?.map(option => (
          <Col key={option.value} span={span}>
            <StyledCheckbox value={option.value} style={{ width: '100%' }}>
              <Flex alignItems="center">
                <Text>{option.label}</Text>
                {option.tooltip && (
                  <Tooltip title={option.tooltip}>
                    <QuestionCircleOutlined style={{ marginLeft: 8 }} />
                  </Tooltip>
                )}
              </Flex>
            </StyledCheckbox>
          </Col>
        ))}
      </Row>
    </StyledCheckboxGroup>
  );
}

CheckboxGroupControl.propTypes = {
  name: PropTypes.string,
  value: PropTypes.array,
  settings: PropTypes.any,
  onChange: PropTypes.func,
};
